import { Link } from '@tanstack/react-router';
import { useEffect } from 'react';
export function NotFoundPage() {
  useEffect(() => {
    const root = document.getElementById('root');
    root?.setAttribute('data-app-notfound', '1');
    return () => root?.removeAttribute('data-app-notfound');
  }, []);
  return (
    <main className="mx-auto max-w-xl px-6 py-24">
      <p className="text-sm uppercase tracking-[.16em] text-muted-foreground">Missing file</p>
      <h1 className="mt-3 text-3xl font-semibold">This page is not in the register.</h1>
      <Link to="/" className="mt-6 inline-block underline">
        Return to FiduciaryFile
      </Link>
    </main>
  );
}
